<template>
<div class="activity">
    <keep-alive include="NDActivityList">
        <router-view :param="param"></router-view>
    </keep-alive>
</div>
</template>

<script>
import {mapActions} from 'vuex'
import {initPage} from 'common/js/mixin'

export default {
    name: 'activity',
    mixins: [initPage],
    data() {
        return {
            param: {
                status: '',
                title: '',
                resulttype: '',
                templatetype: '',
                distype: ''
            }
        }
    },
    mounted() {
        this.setParams(this._.cloneDeep(this.param))
    },
    methods: {
        ...mapActions([
            'setParams'
        ])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.activity {
}
</style>
